import angular from 'angular'

angular
  .module('admin.product_categories.service', [])
  .factory('ProductCategoriesService', ProductCategoriesService)

/** @ngInject */
function ProductCategoriesService($http, $q, API) {
  function list(start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL +
          'admin/product_categories?start=' +
          start +
          '&limit=' +
          limit +
          '&sort=id-asc',
      )
      .success(defered.resolve)

    return defered.promise
  }

  function get(id) {
    var defered = $q.defer()

    $http.get(API.API_URL + 'admin/product_categories/' + id).success(defered.resolve)

    return defered.promise
  }

  function save(model) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + 'admin/product_categories', model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function update(id, model) {
    var defered = $q.defer()

    $http
      .put(API.API_URL + 'admin/product_categories/' + id, model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function remove(id) {
    var defered = $q.defer()

    $http
      .delete(API.API_URL + 'admin/product_categories/' + id)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  return {
    list: list,
    get: get,
    save: save,
    update: update,
    remove: remove,
  }
}
